export function normalizeApiData(data) {
  return data;
}
